import { useNavigate, useSearchParams } from 'react-router-dom';
import { useIdentity } from '../hooks/useIdentity';
import { useSignAndPostLogin } from '../hooks/useSignAndPostLogin';

function LoginSignForm(props: {
  status: 'idle' | 'signing' | 'done' | 'error';
  error: string | null;
  onBack: () => void;
}): JSX.Element {
  const { status, error, onBack } = props;
  return (
    <main>
      <h1>Signer le login</h1>
      {error !== null && <p role="alert">{error}</p>}
      {status === 'signing' && <p>Signature et publication en cours…</p>}
      {status === 'done' && (
        <p>Signature publiée. Retournez sur le 1ᵉʳ appareil.</p>
      )}
      {(status === 'done' || status === 'error') && (
        <button type="button" onClick={onBack}>Retour</button>
      )}
    </main>
  );
}

function LoginSignError(props: {
  title: string;
  message: string;
  onBack: () => void;
}): JSX.Element {
  const { title, message, onBack } = props;
  return (
    <main>
      <h1>{title}</h1>
      <p>{message}</p>
      <button type="button" onClick={onBack}>Retour</button>
    </main>
  );
}

/**
 * Device 2: sign login challenge (hash, nonce) and post to relays.
 * Route: /login-sign?hash=...&nonce=...
 */
export function LoginSignScreen(): JSX.Element {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { identity } = useIdentity();
  const hash = searchParams.get('hash') ?? '';
  const nonce = searchParams.get('nonce') ?? '';
  const { status, error } = useSignAndPostLogin(hash, nonce, identity);
  const goBack = (): void => navigate('/');

  if (hash === '' || nonce === '') {
    return (
      <LoginSignError
        title="Signer le login"
        message="Paramètres manquants : hash et nonce requis (URL ou QR)."
        onBack={goBack}
      />
    );
  }
  if (identity === null) {
    return (
      <LoginSignError
        title="Signer le login"
        message="Identité requise."
        onBack={goBack}
      />
    );
  }
  return <LoginSignForm status={status} error={error} onBack={goBack} />;
}
